export default __webpack_public_path__ + "static/cicovi_logo-02e7e3cf0510ce8be3925e97e581ec32.svg";